//引入样式
// import 'highlight.js/styles/monokai-sublime.css'
import 'highlight.js/styles/atom-one-dark.css'; //黑色主题
// import 'highlight.js/styles/stackoverflow-light.css';  //白色主题
//引入库
import hljs from 'highlight.js'
export function fn_highlight () {
    document.querySelectorAll('pre code').forEach((block) => {
        hljs.highlightBlock(block);
    });
}
